<template>
  <generic-page
    :image="mainImageUrl"
    image-height="95vh"
  >
    <news-card :item="content" />
  </generic-page>
</template>

<script>
import newsCard from "../components/newsCard";
import genericPage from "../components/genericPage";

export default {
  name: "NewsPost",
  components: { genericPage, newsCard },
  data() {
    return {
      mainImageUrl: "",
      content: {
        title: null,
        body: null,
        img: { url: ''},
        imgVertical: { url: ''}
      }
    };
  },
  watch: {
    $route() {
      this.getContent();
    }
  },
  created() {
    this.getMainImageUrl();
    this.getContent();
  },
  methods: {
    track() {
      this.$ga.page(this.$router);
    },
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    async getMainImageUrl() {
      const { data } = await this.$prismic.client.getByUID(
        "puslapiai",
        "naujienos"
      );
      this.mainImageUrl = this.isMobile() ? data.virsutinis_paveikslelis.mobile.url : data.virsutinis_paveikslelis.url
    },
    async getContent() {
      const { data } = await this.$prismic.client.getByUID(
        "naujienos",
        this.$route.params[0]
      );
      this.content = {
        ...this.content,
        title: data.antraste[0].text,
        body: data.tekstas,
        img: this.isMobile() ? data.paveikslelis.mobile : data.paveikslelis,
        imgVertical: this.isMobile()
          ? data.paveikslelis_vertikalus.mobile
          : data.paveikslelis_vertikalus
      };
    }
  }
};
</script>
